<!--
<article style="border: 1px solid black; margin: 10px; padding: 10px;">
  <span *ngIf="card?.examenDataToSend?.cargadoOffline">
    <h3>{{ card.examenData.tipoExamen }} (cargado offline)</h3>
    <div style="display: flex; justify-content: space-around;">
      <div>Trabajador: {{ card.examenData.trabajador.apellido }} {{ card.examenData.trabajador.nombre }} </div>
      <div>{{card.examenData.trabajador.tipoDocumento}}: {{ card.examenData.trabajador.numeroDocumento }} </div>
      <div>fecha asignacion: {{ card.examenData.fechaAsignacion }} </div>
      <div>empresa: {{ card.examenData.empresa.razonSocial }} </div>
      <div>N° Contrato: {{ card.examenData.contrato }} </div>
    </div>
  </span>

  <span *ngIf="!card?.examenDataToSend?.cargadoOffline">
    <h3>{{ card.tipoExamen }} </h3>
    <div style="display: flex; justify-content: space-around;">
      <div>Trabajador: {{ card.apellidoTrabajador }} {{ card.nombreTrabajado }} </div>
      <div>{{card.tipoDocumentoTrabajador}}: {{ card.nroDocumentoTrabajador }} </div>
      <div>fecha asignacion: {{ card.fechaAsignacion }} </div>
      <div>empresa: {{ card.empresaRazonSocial }} </div>
      <div>N° Contrato: {{ card.contrato }} </div>
    </div>
  </span>

  <footer style="
  display: flex;
  justify-content: flex-end;
  align-items: center;">
    <div style="margin-right: 20px;">
      <button class="button" [ngClass]="{'button--hover': card.abierto}" (click)="editExam(card)"
        [disabled]="(card.abierto === false || isOnline === false) ? 'disabeled' : ''">
        Editar
      </button>
    </div>

    <div >
      <button class="button" [ngClass]="{'button--hover': card.abierto}" (click)="showExam(card)"
        [disabled]="isOnline === false ? 'disabeled' : ''">
        Ver
      </button>
    </div>
  </footer>
</article> -->

<!-- todo: esto es ejemplos de cmo serian las etiquetas -->


<article class="app_cargadosCardItem__container">
  <ng-container  *ngIf="card?.examenDataToSend?.cargadoOffline">

    <header class="app_cargadosCardItem__header">
      <h3>{{ card.examenData.provinciaNombreEstudio }}</h3>

      <div style="justify-self: end;">
        <span *ngIf="card?.examenDataToSend?.cargadoOffline" class="app_cargadosCardItem__body_vigencia info"> Cargado offline </span>
        <span  *ngIf="card.enviado && !card?.examenDataToSend?.cargadoOffline" class="app_cargadosCardItem__body_vigencia red"
          style="margin-left: 10px;"> Enviado a la ART
        </span>
      </div>
    </header>
    <section class="app_cargadosCardItem__body">
      <div>
        <div class="app_cargadosCardItem__body_title">Trabajador</div>
        <div>
          <span class="elipsis">{{ card.examenDataToSend?.trabajador?.apellidoNombre ? card.examenDataToSend.trabajador.apellidoNombre
            : card.examenData?.trabajador?.apellidoNombre ? card.examenData.trabajador.apellidoNombre : card.trabajador.apellidoNombre }}</span>
        </div>
        <div>
          <span class="app_cargadosCardItem__body_title">{{card.examenData.trabajador.tipoDocumento}}: </span>
          <span>{{ card.examenData.trabajador.numeroDocumento }}</span>
        </div>
      </div>

      <div>
        <div class="app_cargadosCardItem__body_title">Esops de exposición</div>
        <div *ngIf="card.examenData.esops.length > 0">
          <div>
            <span class="elipsis">
              {{ card.examenData.esops[0].codigo }} - {{ card.examenData.esops[0].descripcion }}
            </span>
          </div>
          <div class="app_cargadosCardItem__body_tinyText">
            1 de {{ card.examenData.esops.length }} esops
          </div>
        </div>
        <div *ngIf="card.examenData.esops.length == 0">
          <span class="elipsis">
            No Posee
          </span>
        </div>
      </div>

      <div>
        <div class="app_cargadosCardItem__body_title">Empresa</div>
        <div>{{ card.examenData.lote.empresa.razonSocial }}</div>
        <div class="app_cargadosCardItem__body_title">N° de Carpeta</div>
        <div>{{ card.examenData.numeroCarpeta }}</div>
      </div>

      <div>
        <div class="app_cargadosCardItem__body_title">N° de contrato</div>
        <div>{{ card.examenData.lote.numeroContrato }}</div>
        <div class="app_cargadosCardItem__body_title">N° de lote</div>
        <div>{{ card.examenData.lote.numeroLote }}</div>
      </div>

    </section>
  </ng-container>

  <ng-container *ngIf="!card?.examenDataToSend?.cargadoOffline">

    <header class="app_cargadosCardItem__header">
      <h3>{{ card.provinciaNombreEstudio }}</h3>

      <div *ngIf="card.enviado" class="app_cargadosCardItem__body_vigencia red" style="justify-self: end;">
        <span> Enviado a la ART </span>
      </div>
    </header>
    <section class="app_cargadosCardItem__body">
      <div>
        <div class="app_cargadosCardItem__body_title">Trabajador</div>
        <div>
          <span class="elipsis">{{ card.examenDataToSend?.trabajador?.apellidoNombre ? card.examenDataToSend.trabajador.apellidoNombre
            : card.examenData?.trabajador?.apellidoNombre ? card.examenData.trabajador.apellidoNombre : card.trabajador.apellidoNombre }}</span>
        </div>
        <div>
          <span class="app_cargadosCardItem__body_title">{{card.trabajador.tipoDocumento}}: </span>
          <span>{{ card.trabajador.numeroDocumento }}</span>
        </div>
      </div>

      <div>
        <div class="app_cargadosCardItem__body_title">Esops de exposición</div>
        <div *ngIf="card.esops.length > 0">
          <div>
            <span class="elipsis">
              {{ card.esops[0].codigo }} - {{ card.esops[0].descripcion }}
            </span>
          </div>
          <div class="app_cargadosCardItem__body_tinyText">
            1 de {{ card.esops.length }} esops
          </div>
        </div>
        <div *ngIf="card.esops.length == 0">
          <span class="elipsis">
            No Posee
          </span>
        </div>
      </div>

      <div>
        <div class="app_cargadosCardItem__body_title">Empresa</div>
        <div>{{ card.lote.empresa.razonSocial }}</div>
        <div class="app_cargadosCardItem__body_title">N° de Carpeta</div>
        <div>{{ card.numeroCarpeta }}</div>
      </div>

      <div>
        <div class="app_cargadosCardItem__body_title">N° de contrato</div>
        <div>{{ card.lote.numeroContrato }}</div>
        <div class="app_cargadosCardItem__body_title">N° de lote</div>
        <div>{{ card.lote.numeroLote }}</div>
      </div>

    </section>
  </ng-container>





<footer class="app_cargadosCardItem__footer">
  <div *ngIf="card.cargadoEnAdjunto === null || !card.cargadoEnAdjunto && !(card?.examenDataToSend?.cargadoOffline && card?.examenDataToSend?.cargadoEnAdjunto ) " style="margin-right: 20px;">
    <button class="button" [ngClass]="{'button--hover': (card?.examenDataToSend?.cargadoOffline || (!card.enviado && isOnline))}"
      (click)="editExam(card)"
      [disabled]="!card?.examenDataToSend?.cargadoOffline && (card.enviado || !isOnline) ? 'disabeled' : ''">
      <i class="buttonIcon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M20.4,3.8c-1-1.2-2.5-1.7-4-1.4c-0.7,0.2-1.3,0.5-1.8,0.9l-2.2,2.2L3.9,14c-0.2,0.2-0.3,0.4-0.3,0.7l-0.2,5.1
            c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.4,0.3,0.7,0.3l0,0l5.1-0.2c0.3,0,0.5-0.1,0.7-0.3l8.5-8.5l0,0l2.1-2.1c0.5-0.5,0.8-1.1,0.9-1.8
            C22.1,6.4,21.5,4.8,20.4,3.8z M9.1,18.6l-3.6,0.1l0.1-3.6l7.5-7.5l3.5,3.5L9.1,18.6z M19.5,8.2L18,9.7l-3.4-3.5L16,4.7
            c0.3-0.3,1.4-1.1,3,0.5S19.8,7.9,19.5,8.2z"/>
        </svg>
      </i>
      Editar
    </button>
  </div>

  <div *ngIf="card.cargadoEnAdjunto === null || !card.cargadoEnAdjunto && !(card?.examenDataToSend?.cargadoOffline && card?.examenDataToSend?.cargadoEnAdjunto )">
    <button class="button button_primary button_primary--hover" (click)="showExam(card)"
      [disabled]="!isOnline && !card?.examenDataToSend?.cargadoOffline ? 'disabeled' : ''">
      <i class="buttonIcon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M12,18.88A10.68,10.68,0,0,1,3.08,14c-.11-.17-.38-.66-.62-1.12a2,2,0,0,1,0-1.88c.24-.46.51-.95.63-1.12a10.6,10.6,0,0,1,17.84,0c.12.17.39.67.63,1.13a2,2,0,0,1,0,1.87c-.24.47-.51,1-.63,1.14A10.67,10.67,0,0,1,12,18.88ZM4.18,11.94h0A8.84,8.84,0,0,0,12,16.88a8.84,8.84,0,0,0,7.83-4.94h0A8.84,8.84,0,0,0,12,7a8.84,8.84,0,0,0-7.83,4.94Z"/>
          <path d="M12,16.14A4.14,4.14,0,1,1,16.15,12,4.14,4.14,0,0,1,12,16.14Zm0-6.27A2.14,2.14,0,1,0,14.15,12,2.14,2.14,0,0,0,12,9.87Z"/>
        </svg>
      </i>
      Ver
    </button>
  </div>

  <div *ngIf="card.cargadoEnAdjunto && card.attachments?.length > 0">
    <button class="button"
      [disabled]="!card.attachments[0]?.archivoBase64 || !isOnline">

      <a *ngIf="card.attachments[0]?.archivoBase64 && isOnline"
        [href]="card.attachments[0]?.archivoBase64"
        class="active"
        style="color: grey; text-decoration: none"
        download="{{card.attachments[0]?.nombreOriginal}}">
        <span> Ver archivo </span>
      </a>

      <a *ngIf="!card.attachments[0]?.archivoBase64 || !isOnline">
        <span> Ver archivo </span>
      </a>
    </button>
  </div>

  <div *ngIf="card?.examenDataToSend?.cargadoOffline && card?.examenDataToSend?.cargadoEnAdjunto && !isOnline">
    <button class="button" [disabled]="card?.examenDataToSend?.cargadoOffline && card?.examenDataToSend?.cargadoEnAdjunto && !isOnline ? 'disabeled' : ''">
      <span>
        Ver archivo
      </span>
    </button>
  </div>
</footer>
